"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createExternal = exports.updateAll = exports.create = exports.getLayersOnMainCamera = exports.ELayerType = exports.getLayers = exports.getMasterLayers = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
function getMasterLayers() {
    assert_sidecar_1.assert.notNil(_masterLayers);
    return _masterLayers;
}
exports.getMasterLayers = getMasterLayers;
function getLayers() {
    assert_sidecar_1.assert.notNil(_layers);
    return _layers;
}
exports.getLayers = getLayers;
var ELayerType;
(function (ELayerType) {
    ELayerType[ELayerType["None"] = 0] = "None";
    ELayerType[ELayerType["Background"] = 1] = "Background";
    ELayerType[ELayerType["Game"] = 2] = "Game";
    ELayerType[ELayerType["Ui"] = 3] = "Ui";
})(ELayerType = exports.ELayerType || (exports.ELayerType = {}));
var _masterLayers = null;
var _layers = null;
var _layersOnMainCamera = [];
function getLayersOnMainCamera() {
    return _layersOnMainCamera;
}
exports.getLayersOnMainCamera = getLayersOnMainCamera;
var depth = 100;
function create() {
    var scene = common_sidecar_1.common.getPhaserScene();
    _masterLayers = {
        background: scene.add.layer(),
        game: scene.add.layer(),
        ui: scene.add.layer(),
        debug: scene.add.layer(),
    };
    _layers = {
        background: createLayer(ELayerType.Game, _masterLayers.game),
        board: createLayer(ELayerType.Game, _masterLayers.game),
        pieces: createLayer(ELayerType.Game, _masterLayers.game),
        boardRoof: createLayer(ELayerType.Game, _masterLayers.game),
        abovePieces: createLayer(ELayerType.Game, _masterLayers.game),
        particles: createLayer(ELayerType.Game, _masterLayers.game),
        uiOnCam: createLayer(ELayerType.Game, _masterLayers.game),
        uiGame: createLayer(ELayerType.Game, _masterLayers.ui, true),
        ui1: createLayer(ELayerType.Game, _masterLayers.ui, true),
        uiMenu: createLayer(ELayerType.Ui, _masterLayers.ui, true),
        uiMenuMain: createLayer(ELayerType.Ui, _masterLayers.ui, true),
        uiMessage: createLayer(ELayerType.Ui, _masterLayers.ui, true),
        uiTop: createLayer(ELayerType.Ui, _masterLayers.ui, true),
        debug: createLayer(ELayerType.Ui, _masterLayers.debug),
    };
}
exports.create = create;
function updateAll() { }
exports.updateAll = updateAll;
function createExternal(baseLayer) {
    var scene = common_sidecar_1.common.getPhaserScene();
    var c = scene.add.container(0, 0);
    baseLayer.add(c);
    return c;
}
exports.createExternal = createExternal;
function createLayer(type, masterLayer, isUi) {
    if (isUi === void 0) { isUi = false; }
    var scene = common_sidecar_1.common.getPhaserScene();
    assert_sidecar_1.assert.notNil(masterLayer);
    assert_sidecar_1.assert.notNil(_masterLayers);
    var c = scene.add.container(0, 0);
    masterLayer.add(c);
    // masterLayer.add(c)
    c.depth = depth;
    depth += 100;
    if (type === ELayerType.Game) {
        if (!isUi) {
            _layersOnMainCamera.push(c);
        }
    }
    if (isUi) {
        c.scrollFactorX = 0;
        c.scrollFactorY = 0;
    }
    return c;
}
